import React, { useState, useEffect, useRef, useCallback } from "react";
import jsPDF from "jspdf";
import {
  fontStyles,
  labelColors,
  valueColors,
  lineColors,
} from "../../components/fontStylesColors"; // adjust path as needed

import FormSection from "../../components/FormSection";
import TodoList from "../../components/TodoList";
//import { generateComplexCaptcha } from "../../components/Captcha";
//import Captcha from "../../components/Captcha";
import HiddenQRCode from "../../components/HiddenQRCode";
import ImageSelector from "../../components/ImageSelector";
import ImagePhoto from "../../components/ImagePhoto";
import ImagePhotoRound from "../../components/ImagePhotoRound";
import PaymentButton from "../../components/PaymentButton";
import Semester from "../../components/Semester";
import { registerRoboto } from "../../fonts/registerRoboto"; // file that loads Roboto, Caveat, etc.
// client-side call to server generatePDF endpoint
import { generatePDF } from "./generatePDF";

import "../../components/Leto.css";

function Leto() {
  // -------------------------
  // Form state
  // -------------------------
  const [formData, setFormData] = useState({
    name1: "",
    study1: "",
    AdmNo1: "",
    School1: "",
    comm: "",
    selection1: "Name",
    selection2: "Study",
    selection3: "AdmNo",
    selection4: "School",
    selection5: "Dream",
  });

  const [formData1, setFormData1] = useState({
    selection6: "Semester",
    selection7: "",
  });

  // -------------------------
  // Images & selectors
  // -------------------------
  const [imagesFromFolders, setImagesFromFolders] = useState([]); // for dynamic import (client)
  const [filteredImages, setFilteredImages] = useState([]);
  const [filter, setFilter] = useState("all");
  const [selectedImages, setSelectedImages] = useState([]);
  const [highlightedImages, setHighlightedImages] = useState([]);
  const [resetDefaults, setResetDefaults] = useState(0);
  const [showValidationMessage, setShowValidationMessage] = useState(false);

  // -------------------------
  // Model selection (rect/round/nop)
  // -------------------------
  const [model, setModel] = useState("rect");
  const handleChange5 = useCallback((e) => setModel(e.target.value), []);

  // -------------------------
  // Promo & Payment
  // -------------------------
  const [isPaid, setIsPaid] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false); // prevents duplicate downloads
  const hasDownloadedRef = useRef(false); // avoids double effect (StrictMode)
  const [amount, setAmount] = useState(2000);
  
  const [errorPayment, setErrorPayment] = useState("");
  const [downloadTimer, setDownloadTimer] = useState(0);
const timerRef = useRef(null);
const timeoutRef = useRef(null);
const downloadStartedRef = useRef(false);







  // -------------------------
  // Load images from client folders (webpack require.context)
  // -------------------------
  useEffect(() => {
    try {
      const importAllImages = (context) => context.keys().map(context);

      const loadedImages = [
        ...importAllImages(
          require.context("./images", false, /\.(png|jpe?g)$/)
        ).map((img) => ({ src: img, category: "general" })),
        ...importAllImages(
          require.context("./Animation", false, /\.(png|jpe?g)$/)
        ).map((img) => ({ src: img, category: "animation" })),
        ...importAllImages(
          require.context("./Technology", false, /\.(png|jpe?g)$/)
        ).map((img) => ({ src: img, category: "technology" })),
        ...importAllImages(
          require.context("./Sports", false, /\.(png|jpe?g)$/)
        ).map((img) => ({ src: img, category: "sports" })),
        ...importAllImages(
          require.context("./Science", false, /\.(png|jpe?g)$/)
        ).map((img) => ({ src: img, category: "science" })),
      ];

      setImagesFromFolders(loadedImages);
    } catch (err) {
      // in case require.context isn't available or folders not present — keep imagesFromFolders empty
      console.warn("Image folder import failed:", err);
    }
  }, []);

  const getFilteredImages = useCallback(() => {
    // Option B: show all images always, user requested unified borders
    return imagesFromFolders;
  }, [imagesFromFolders]);

  useEffect(() => {
    const all = getFilteredImages();
    if (filter === "all") setFilteredImages(all);
    else setFilteredImages(all.filter((img) => img.category === filter));
  }, [filter, imagesFromFolders, getFilteredImages]);

  // -------------------------
  // Validation & todos
  // -------------------------
  const namePattern =
    /^[\p{L}\p{N}'.:-]+(?: [\p{L}\p{N}'.@:-]+)* ?$/u; /* unicode letters+numbers */

  const formatName = useCallback((value) => {
    return value
      .toLowerCase()
      .replace(/ +/g, " ")
      .replace(/\b\w/g, (ch) => ch.toUpperCase());
  }, []);

  const defaultTodos = [];
  const [todos, setTodos] = useState(defaultTodos);
  const [errors, setErrors] = useState({});
  //const [captcha, setCaptcha] = useState(generateCaptcha());
  //const [userCaptcha, setUserCaptcha] = useState("");
  const [todoError, setTodoError] = useState("");
  //const [captchaError, setCaptchaError] = useState("");

  /*function generateCaptcha() {
    const { imageUrl, text } = generateComplexCaptcha();
    return { imageUrl, text };
  }

  const refreshCaptcha = useCallback(() => {
    setCaptcha(generateCaptcha());
    setUserCaptcha("");
    setCaptchaError("");
  }, []);
  */

  const validateField = useCallback((name, value) => {
    let errorMessage = "";
    const v = (value || "").toString();

    if (!v.trim()) errorMessage = "This field is required";
    else if (v.length < 2) errorMessage = "Must be at least 2 characters";
    else if (v.length > 25) errorMessage = "Must not exceed 25 characters";
    else if (!namePattern.test(v)) errorMessage = "Spl chars ' . @ - : allows only ";

    setErrors((prev) => ({ ...prev, [name]: errorMessage }));
    return errorMessage;
  }, []);

  // -------------------------
  // Input handlers
  // -------------------------
  const handleChange = useCallback(
    (e) => {
      const { name, value } = e.target;
      const formattedValue = name === "AdmNo1" ? value : formatName(value);
      setFormData((prev) => ({ ...prev, [name]: formattedValue }));
      validateField(name, formattedValue);
    },
    [formatName, validateField]
  );

  const handleChange1 = useCallback((e) => {
    const { name, value } = e.target;
    setFormData1((prev) => ({ ...prev, [name]: value }));
  }, []);

  // -------------------------
  // Todos handlers
  // -------------------------
  const handleTodoInputChange = useCallback((newTodos) => {
    setTodos(newTodos);
    if (newTodos.length > 0) setTodoError("");
  }, []);

  const handleDeleteAllTodos = useCallback(() => setTodos([]), []);

  // -------------------------
  // Photo uploads
  // -------------------------
  const [photos, setPhotos] = useState([null, null, null, null]);
  const [validationMessage, setValidationMessage] = useState("");
  const fileInputsRef = useRef([]);
  const labels = ["Photo1", "Photo2", "Photo3", "Photo4"];

  const handlePhotoUpload = useCallback((photo, index) => {
    setPhotos((prev) => {
      const updated = [...prev];
      updated[index] = photo;
      if (updated.some(Boolean)) setValidationMessage("");
      return updated;
    });
  }, []);

  // -------------------------
  // Captcha handler
  // -------------------------
  /*const handleCaptchaChange = useCallback((value) => {
    setUserCaptcha(value);
    if (value === captcha.text) setCaptchaError("");
  }, [captcha]);*/

  // -------------------------
  // Process / superscript helpers
  // -------------------------
  const processInput = useCallback((inputText) => {
    const cleanedInput = (inputText || "").replace(/[ʰ-˿ᴀ-ᵿ]/g, "");
    return cleanedInput.replace(/\b(\d+)\b/g, (match, number) => {
      const num = parseInt(number, 10);
      let suffix = "th";
      if (num % 10 === 1 && num % 100 !== 11) suffix = "st";
      else if (num % 10 === 2 && num % 100 !== 12) suffix = "nd";
      else if (num % 10 === 3 && num % 100 !== 13) suffix = "rd";
      return `${num}${suffix}`;
    });
  }, []);

  const addSuperscriptSuffix = useCallback((text) => {
    return (text || "").replace(/(\d+)(st|nd|rd|th)/g, (match, number, suffix) => {
      return `${number}${suffix}`;
    });
  }, []);

  // -------------------------
  // Form validation before payment / download
  // -------------------------
  const validateForm = useCallback(() => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (!key.includes("selection")) {
        const err = validateField(key, formData[key]);
        if (err) newErrors[key] = err;
      }
    });

    if (todos.length === 0) {
      newErrors.todoError = "Please add at least one subject.";
      setTodoError("Please add at least one subject.");
    } else setTodoError("");

    if (selectedImages.length === 0) {
      newErrors.imageError = "Please select at least one image.";
      setShowValidationMessage(true);
    } else setShowValidationMessage(false);

    if (model !== "nop" && photos.every((p) => !p)) {
      setValidationMessage("Upload at least one photo");
      newErrors.photosError = "Upload at least one photo";
    } else setValidationMessage("");

    /*if (userCaptcha !== captcha.text) {
      newErrors.captchaError = "Invalid captcha!";
      setCaptchaError("Invalid captcha!");
    } else setCaptchaError("");
*/
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [formData, photos, todos, selectedImages, validateField, model]);

  // -------------------------
  // Convert URL to base64 (client)
  // -------------------------
  const convertUrlToBase64 = useCallback(async (url) => {
    if (!url) return null;
    const res = await fetch(url);
    const blob = await res.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }, []);
  
  
  
  //filename while download pdf
  const makeSafeFileName = (name = "student") =>
  name
    .toLowerCase()
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_]/g, "");


  // -------------------------
  // downloadPDF function (stable, single responsibility)
  // -------------------------
  const downloadPDF = useCallback(async () => {
    // Guard to prevent re-entry
    if (isDownloading) return;
    setIsDownloading(true);

    try {
      // Convert border images to base64 (they might already be dataURLs or webpack urls)
      const selectedImagesBase64 = await Promise.all(
        selectedImages.map(async (img) => {
          try {
            if (typeof img === "string") {
              // If it's already a data URL, leave as-is; if it's a webpack resource path -> fetch & convert
              if (img.startsWith("data:")) return img;
              // webpack images are accessible; convert by fetching blob
              return await convertUrlToBase64(img);
            }
            return img;
          } catch (err) {
            console.warn("Failed to convert selected image:", err);
            return null;
          }
        })
      );

      // Convert uploaded photos to base64 (keep nulls)
      const photosBase64 = await Promise.all(
        photos.map(async (photo) => {
          if (!photo) return null;
          if (typeof photo === "string" && photo.startsWith("data:")) return photo;
          return await convertUrlToBase64(photo);
        })
      );

      const payload = {
        formData,
        formData1,
        todos,
        selectedImages: selectedImagesBase64.filter(Boolean),
        photos: photosBase64,
        model,
      };

	 

// ✅ ADD THIS
await generatePDF({
  formData,
  formData1,
  todos,
  selectedImages: selectedImagesBase64.filter(Boolean),
  photos: photosBase64,
  model,
});

      // small delay to ensure browser begins download / open
      setTimeout(() => {
        // reload only after download opened successfully
        window.location.reload();
      }, 1200);
    } catch (err) {
      console.error("PDF generation / download failed:", err);
      setErrorPayment("PDF generation failed. Try again.");
    } finally {
      setIsDownloading(false);
      hasDownloadedRef.current = true; // ensure we don't try again
    }
  }, [
    selectedImages,
    photos,
    formData,
    formData1,
    todos,
    model,
    convertUrlToBase64,
    isDownloading,
  ]);





// ✅ PASTE THESE HERE 👇 (before useEffect)
  const cleanup = () => {
    clearInterval(timerRef.current);
    clearTimeout(timeoutRef.current);
  };

  const triggerDownload = async (reason) => {
    if (downloadStartedRef.current) return;
    downloadStartedRef.current = true;

    cleanup();

    console.log("⬇️ Download started:", reason); // you can remove later

    try {
      await downloadPDF();
    } catch (err) {
      console.error("Download failed:", err);
    }
  };




  // -------------------------
  // Effect: fire download once after successful payment
  // StrictMode-safe: guarded by hasDownloadedRef and isPaid
  // -------------------------
  useEffect(() => {
  if (!isPaid) return;
  if (hasDownloadedRef.current) return;

  hasDownloadedRef.current = true;

  const MAX_WAIT = 10; // seconds
  setDownloadTimer(MAX_WAIT);

  // ⏱ Countdown UI (10 → 0)
  timerRef.current = setInterval(() => {
    setDownloadTimer((prev) => {
      if (prev <= 1) {
        clearInterval(timerRef.current);
        return 0;
      }
      return prev - 1;
    });
  }, 1000);

  // ⛔ Hard stop after 10s (force download)
  timeoutRef.current = setTimeout(() => {
    triggerDownload("timeout");
  }, MAX_WAIT * 1000);

  // ⚡ Try downloading immediately (no waiting)
  (async () => {
    const ok = validateForm();
    if (!ok) {
      cleanup();
      setIsPaid(false);
      hasDownloadedRef.current = false;
      return;
    }

    triggerDownload("ready");
  })();

  return cleanup;
}, [isPaid, validateForm]);

  // -------------------------
  // handle form submit (button press)
  // -------------------------
  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (!validateForm()) return;
      // here you might open payment dialog which will setIsPaid(true) after success
    },
    [validateForm]
  );

  // -------------------------
  // Reset form after download (only when needed)
  // -------------------------
  const formRef = useRef(null);
  const resetForm = useCallback(() => {
    if (formRef.current) formRef.current.reset();

    setFormData({
      name1: "",
      study1: "",
      AdmNo1: "",
      School1: "",
      comm: "",
      selection1: "Name",
      selection2: "Study",
      selection3: "AdmNo",
      selection4: "School",
      selection5: "Dream",
    });

    setFormData1({ selection6: "Semester", selection7: "" });
    setTodos(defaultTodos);
    //setUserCaptcha("");
    //setCaptcha(generateCaptcha());
    setTodoError("");
    setSelectedImages([]);
    setHighlightedImages([]);
    setFilter("all");
    setResetDefaults((s) => s + 1);
    setErrors({});
    setPhotos([null, null, null, null]);
    fileInputsRef.current.forEach((inp) => inp && (inp.value = ""));
    setValidationMessage("");
    setIsPaid(false);
    setAmount(2000);
    //setDiscount(0);
    //setPromoCode("");
    setIsDownloading(false);
    hasDownloadedRef.current = false;
  }, []);

  // -------------------------
  // UI
  // -------------------------
  return (
    <div
      className="container"
      style={{
        padding: "1rem",
        fontFamily: "Arial, sans-serif",
        backgroundColor: "#f7f7f7",
        maxWidth: "100%",
        margin: "0 auto",
      }}
    >
      <form
        ref={formRef}
        onSubmit={handleSubmit}
        style={{
          backgroundColor: "#ffffff",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "10px",
            fontFamily: "Arial, sans-serif",
          }}
        >
          <div style={{ marginBottom: "0px" }}>
            <FormSection
              formData={formData}
              handleChange={handleChange}
              errors={errors}
            />
            <Semester value={formData1} onChange={handleChange1} />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0px",
              maxWidth: "100%",
            }}
          >
            <TodoList todos={todos} setTodos={handleTodoInputChange} />
            {todoError && <p style={{ color: "red" }}>{todoError}</p>}

            <button
              type="button"
              onClick={handleDeleteAllTodos}
              style={{
                marginTop: "10px",
                padding: "10px 20px",
                backgroundColor: "#ff4d4d",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Delete All Subjects
            </button>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              padding: "20px",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                padding: "20px",
                border: "2px solid #007bff",
                borderRadius: "10px",
                backgroundColor: "#f8f9fa",
                maxWidth: "100%",
              }}
            >
              <h3 style={{ textAlign: "center", color: "#007bff" }}>
                Choose Border Styles
              </h3>
              <ImageSelector
                images={filteredImages}
                selectedImages={selectedImages}
                highlightedImages={highlightedImages}
                setSelectedImages={setSelectedImages}
                setHighlightedImages={setHighlightedImages}
                setShowValidationMessage={setShowValidationMessage}
                setFilter={setFilter}
                showValidationMessage={showValidationMessage}
                resetDefaults={resetDefaults}
              />
            </div>
          </div>

          {/* Model Selection */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <label
              htmlFor="photo-style"
              style={{
                fontSize: "1rem",
                fontWeight: "600",
                padding: "6px 12px",
                borderRadius: "10px",
                background: "linear-gradient(135deg, #fce4ec, #f8bbd0)",
                color: "#4a148c",
                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                border: "1px solid #f48fb1",
                whiteSpace: "nowrap",
              }}
            >
              Choose Photo Style
            </label>
            <select
              id="photo-style"
              value={model}
              onChange={handleChange5}
              style={{
                flex: "1",
                minWidth: "100px",
                padding: "8px 12px",
                borderRadius: "10px",
                border: "1px solid #ccc",
                fontSize: "1rem",
                background: "linear-gradient(135deg, #fefefe, #e0f7fa)",
                color: "#263238",
                boxShadow: "0px 4px 8px rgba(0,0,0,0.08)",
                transition: "background-color 0.3s ease",
                cursor: "pointer",
              }}
            >
              <option value="rect">Rectangle</option>
              
            </select>
          </div>
        </div>

        {/* upload Photo */}
        {model !== "nop" && (
          <div className="container">
            <div className="grid-container">
              {labels.map((label, index) =>
                model === "rect" ? (
                  <ImagePhoto
                    key={index}
                    index={index}
                    label={label}
                    setImage={(photo) => handlePhotoUpload(photo, index)}
                    images={photos}
                    setImages={setPhotos}
                    fileInputsRef={fileInputsRef}
                    shape="rect"
                  />
                ) : (
                  <ImagePhotoRound
                    key={index}
                    index={index}
                    label={label}
                    setImage={(photo) => handlePhotoUpload(photo, index)}
                    images={photos}
                    setImages={setPhotos}
                    fileInputsRef={fileInputsRef}
                    shape="round"
                  />
                )
              )}
              {validationMessage && (
                <p className="validation-message">{validationMessage}</p>
              )}
            </div>
          </div>
        )}

       

        
           <div style={{ marginTop: "20px" }}>
  <PaymentButton
    setIsPaid={setIsPaid}
    amount={amount}
    validateForm={validateForm}
  />
</div>

        {isPaid && !isDownloading && (
  <p style={{ color: "#28a745", fontWeight: "bold" }}>
    Payment Successful... Downloading in {downloadTimer}s.
  </p>
)}


            </form>

      {/* Hidden QR Codes */}
      {todos.map((todo, index) => (
        <HiddenQRCode
          key={`qr-${index}`}
          id={`qr-${index}`}
          value={
            `I'm ${formData.name1}\n
            Studying ${formData.study1}\n
            My ${formData.selection5} is ${formData.comm}`
          }
        />
      ))}

    </div>
);
}

export default Leto;
